import React from 'react';

const Twitter = ({...props}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
    <path fill="#FFF" d="M22.561 8.69a7.207 7.207 0 0 1-2.07.567 3.602 3.602 0 0 0 1.585-1.993 7.183 7.183 0 0 1-2.29.873 3.603 3.603 0 0 0-6.138 3.286 10.232 10.232 0 0 1-7.426-3.764 3.593 3.593 0 0 0-.487 1.812c0 1.249.636 2.352 1.602 2.999a3.61 3.61 0 0 1-1.633-.45v.044a3.603 3.603 0 0 0 2.892 3.533c-.302.084-.62.126-.95.126-.232 0-.458-.021-.677-.063a3.603 3.603 0 0 0 3.365 2.5 7.23 7.23 0 0 1-4.474 1.543c-.291 0-.579-.016-.86-.05a10.204 10.204 0 0 0 5.522 1.618c6.629 0 10.251-5.489 10.251-10.25 0-.157-.003-.313-.01-.466a7.292 7.292 0 0 0 1.798-1.865"/>
  </svg>
);

export default Twitter;